var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"caption-container"},[_c('div',{staticClass:"caption",style:('color:' + _vm.options.color)},[_vm._v(_vm._s(_vm.options.text))])])}
var staticRenderFns = []

export { render, staticRenderFns }